"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Box = require("../Box/Box");

var _Icons = _interopRequireDefault(require("../Icons/Icons"));

var _styledComponents = require("styled-components");

var _Button = require("./Button.style");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var IconMap = Object.keys(_Icons.default).reduce(function (accumulator, tagName) {
  accumulator[tagName] = _Icons.default[tagName];
  return accumulator;
}, {});

var ButtonIcon = function ButtonIcon(_ref) {
  var buttonIcon = _ref.buttonIcon,
      buttonIconPosition = _ref.buttonIconPosition,
      buttonType = _ref.buttonType,
      brand = _ref.brand,
      outline = _ref.outline;
  var IconComponent = IconMap[buttonIcon];

  var GentuxIconColor = function GentuxIconColor(buttonType) {
    switch (buttonType) {
      case 'info':
        return 'textPrimary';

      case 'primary':
        return 'black';

      case 'danger':
        return 'danger';

      case 'success':
        return 'green';

      case 'link':
        return 'textPrimary';

      default:
        return 'black';
    }
  };

  var MenguinIconColor = function MenguinIconColor(buttonType) {
    switch (buttonType) {
      case 'info':
        return 'primary';

      case 'primary':
        return 'black';

      case 'danger':
        return 'danger';

      case 'success':
        return 'green';

      case 'link':
        return 'textPrimary';

      default:
        return 'black';
    }
  };

  var MenguinIconColorHover = function MenguinIconColorHover(buttonType) {
    switch (buttonType) {
      case 'info':
        return 'white';

      case 'primary':
        return 'white';

      case 'danger':
        return 'white';

      case 'success':
        return 'white';

      default:
        return 'black';
    }
  };

  return brand === 'menguin' ? _react.default.createElement(_Box.Box, {
    className: "button-icon-wrap"
  }, _react.default.createElement(IconComponent, {
    color: outline || buttonType === 'link' ? MenguinIconColor(buttonType) : buttonType === 'default' ? 'black' : 'white',
    className: "button-icon-base"
  }), (outline || buttonType === 'link') && _react.default.createElement(IconComponent, {
    color: MenguinIconColorHover(buttonType),
    className: "button-icon-hover",
    style: {
      position: 'absolute',
      top: 0
    }
  })) : _react.default.createElement(_Box.Box, {
    className: "button-icon-wrap"
  }, _react.default.createElement(IconComponent, {
    color: outline || buttonType === 'link' ? GentuxIconColor(buttonType) : buttonType === 'default' || buttonType === 'info' ? 'black' : 'white',
    className: "button-icon-base"
  }), _react.default.createElement(IconComponent, {
    color: "black",
    className: "button-icon-hover"
  }));
}; // Component


var Button =
/*#__PURE__*/
function (_Component) {
  _inherits(Button, _Component);

  function Button() {
    _classCallCheck(this, Button);

    return _possibleConstructorReturn(this, _getPrototypeOf(Button).apply(this, arguments));
  }

  _createClass(Button, [{
    key: "render",
    value: function render() {
      return this.props.href !== '' || this.props.isAnchor ? _react.default.createElement(_Button.StyledButtonLink, _extends({
        href: this.props.href
      }, this.props), this.props.buttonIcon !== undefined && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(ButtonIcon, {
        outline: this.props.outline,
        buttonIcon: this.props.buttonIcon,
        buttonType: this.props.buttonType,
        brand: this.props.theme.brand
      }), _react.default.createElement(_Box.Box, {
        as: "span",
        pr: 2
      })), this.props.children) : _react.default.createElement(_Button.StyledButton, _extends({
        type: "button"
      }, this.props), this.props.buttonIcon !== undefined && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(ButtonIcon, {
        outline: this.props.outline,
        buttonIcon: this.props.buttonIcon,
        buttonType: this.props.buttonType,
        brand: this.props.theme.brand
      }), _react.default.createElement(_Box.Box, {
        as: "span",
        pr: 2
      })), this.props.children);
    }
  }]);

  return Button;
}(_react.Component);

Button.displayName = 'Button'; // Prop Types

Button.propTypes = {
  buttonType: _propTypes.default.string.isRequired,
  // info, primary
  disabled: _propTypes.default.bool,
  outline: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  href: _propTypes.default.string,
  size: _propTypes.default.string,
  block: _propTypes.default.bool,
  isAnchor: _propTypes.default.bool,
  buttonIcon: _propTypes.default.string,
  buttonIconPosition: _propTypes.default.string,
  // margin
  margin: _propTypes.default.number,
  marginXs: _propTypes.default.number,
  marginSm: _propTypes.default.number,
  marginMd: _propTypes.default.number,
  marginLg: _propTypes.default.number,
  marginXl: _propTypes.default.number,
  marginTop: _propTypes.default.number,
  marginXsTop: _propTypes.default.number,
  marginSmTop: _propTypes.default.number,
  marginMdTop: _propTypes.default.number,
  marginLgTop: _propTypes.default.number,
  marginXlTop: _propTypes.default.number,
  marginRight: _propTypes.default.number,
  marginXsRight: _propTypes.default.number,
  marginSmRight: _propTypes.default.number,
  marginMdRight: _propTypes.default.number,
  marginLgRight: _propTypes.default.number,
  marginXlRight: _propTypes.default.number,
  marginBottom: _propTypes.default.number,
  marginXsBottom: _propTypes.default.number,
  marginSmBottom: _propTypes.default.number,
  marginMdBottom: _propTypes.default.number,
  marginLgBottom: _propTypes.default.number,
  marginXlBottom: _propTypes.default.number,
  marginLeft: _propTypes.default.number,
  marginXsLeft: _propTypes.default.number,
  marginSmLeft: _propTypes.default.number,
  marginMdLeft: _propTypes.default.number,
  marginLgLeft: _propTypes.default.number,
  marginXlLeft: _propTypes.default.number,
  marginX: _propTypes.default.number,
  marginXsX: _propTypes.default.number,
  marginSmX: _propTypes.default.number,
  marginMdX: _propTypes.default.number,
  marginLgX: _propTypes.default.number,
  marginXlX: _propTypes.default.number,
  marginY: _propTypes.default.number,
  marginXsY: _propTypes.default.number,
  marginSmY: _propTypes.default.number,
  marginMdY: _propTypes.default.number,
  marginLgY: _propTypes.default.number,
  marginXlY: _propTypes.default.number,
  // padding
  padding: _propTypes.default.number,
  paddingXs: _propTypes.default.number,
  paddingSm: _propTypes.default.number,
  paddingMd: _propTypes.default.number,
  paddingLg: _propTypes.default.number,
  paddingXl: _propTypes.default.number,
  paddingTop: _propTypes.default.number,
  paddingXsTop: _propTypes.default.number,
  paddingSmTop: _propTypes.default.number,
  paddingMdTop: _propTypes.default.number,
  paddingLgTop: _propTypes.default.number,
  paddingXlTop: _propTypes.default.number,
  paddingRight: _propTypes.default.number,
  paddingXsRight: _propTypes.default.number,
  paddingSmRight: _propTypes.default.number,
  paddingMdRight: _propTypes.default.number,
  paddingLgRight: _propTypes.default.number,
  paddingXlRight: _propTypes.default.number,
  paddingBottom: _propTypes.default.number,
  paddingXsBottom: _propTypes.default.number,
  paddingSmBottom: _propTypes.default.number,
  paddingMdBottom: _propTypes.default.number,
  paddingLgBottom: _propTypes.default.number,
  paddingXlBottom: _propTypes.default.number,
  paddingLeft: _propTypes.default.number,
  paddingXsLeft: _propTypes.default.number,
  paddingSmLeft: _propTypes.default.number,
  paddingMdLeft: _propTypes.default.number,
  paddingLgLeft: _propTypes.default.number,
  paddingXlLeft: _propTypes.default.number,
  paddingX: _propTypes.default.number,
  paddingXsX: _propTypes.default.number,
  paddingSmX: _propTypes.default.number,
  paddingMdX: _propTypes.default.number,
  paddingLgX: _propTypes.default.number,
  paddingXlX: _propTypes.default.number,
  paddingY: _propTypes.default.number,
  paddingXsY: _propTypes.default.number,
  paddingSmY: _propTypes.default.number,
  paddingMdY: _propTypes.default.number,
  paddingLgY: _propTypes.default.number,
  paddingXlY: _propTypes.default.number
};
Button.defaultProps = {
  disabled: false,
  outline: false,
  onClick: function onClick() {},
  href: '',
  size: '',
  block: false,
  buttonType: 'default',
  isAnchor: false,
  buttonIcon: undefined,
  buttonIconPosition: 'left',
  // margin
  margin: undefined,
  marginXs: undefined,
  marginSm: undefined,
  marginMd: undefined,
  marginLg: undefined,
  marginXl: undefined,
  marginTop: undefined,
  marginXsTop: undefined,
  marginSmTop: undefined,
  marginMdTop: undefined,
  marginLgTop: undefined,
  marginXlTop: undefined,
  marginRight: undefined,
  marginXsRight: undefined,
  marginSmRight: undefined,
  marginMdRight: undefined,
  marginLgRight: undefined,
  marginXlRight: undefined,
  marginBottom: undefined,
  marginXsBottom: undefined,
  marginSmBottom: undefined,
  marginMdBottom: undefined,
  marginLgBottom: undefined,
  marginXlBottom: undefined,
  marginLeft: undefined,
  marginXsLeft: undefined,
  marginSmLeft: undefined,
  marginMdLeft: undefined,
  marginLgLeft: undefined,
  marginXlLeft: undefined,
  marginX: undefined,
  marginXsX: undefined,
  marginSmX: undefined,
  marginMdX: undefined,
  marginLgX: undefined,
  marginXlX: undefined,
  marginY: undefined,
  marginXsY: undefined,
  marginSmY: undefined,
  marginMdY: undefined,
  marginLgY: undefined,
  marginXlY: undefined,
  // padding
  padding: undefined,
  paddingXs: undefined,
  paddingSm: undefined,
  paddingMd: undefined,
  paddingLg: undefined,
  paddingXl: undefined,
  paddingTop: undefined,
  paddingXsTop: undefined,
  paddingSmTop: undefined,
  paddingMdTop: undefined,
  paddingLgTop: undefined,
  paddingXlTop: undefined,
  paddingRight: undefined,
  paddingXsRight: undefined,
  paddingSmRight: undefined,
  paddingMdRight: undefined,
  paddingLgRight: undefined,
  paddingXlRight: undefined,
  paddingBottom: undefined,
  paddingXsBottom: undefined,
  paddingSmBottom: undefined,
  paddingMdBottom: undefined,
  paddingLgBottom: undefined,
  paddingXlBottom: undefined,
  paddingLeft: undefined,
  paddingXsLeft: undefined,
  paddingSmLeft: undefined,
  paddingMdLeft: undefined,
  paddingLgLeft: undefined,
  paddingXlLeft: undefined,
  paddingX: undefined,
  paddingXsX: undefined,
  paddingSmX: undefined,
  paddingMdX: undefined,
  paddingLgX: undefined,
  paddingXlX: undefined,
  paddingY: undefined,
  paddingXsY: undefined,
  paddingSmY: undefined,
  paddingMdY: undefined,
  paddingLgY: undefined,
  paddingXlY: undefined
};

var _default = (0, _styledComponents.withTheme)(Button);

exports.default = _default;